import { TParScoreType } from '../../../../../../../store/admin/roundFormats/store';

interface IParScoreTypeMap {
  name: string;
  value: TParScoreType;
}

export const scoreValues: IParScoreTypeMap[] = [
  { name: 'Better than eagle', value: -3 },
  { name: 'Eagle', value: -2 },
  { name: 'Birdie', value: -1 },
  { name: 'Par', value: 0 },
  { name: 'Bogey', value: 1 },
  { name: 'Dbl Bogey', value: 2 },
  { name: 'Worse than Dbl Bogey', value: 3 }
];
